import { SizableText, styled, YStack } from 'tamagui';

/**
 * Styled step box component.
 * Represents an individual step in the step indicator.
 * Uses variants to style active vs inactive states.
 */
export const StepBox = styled(YStack, {
  height: 4,
  borderRadius: '$true',
  variants: {
    isActive: {
      true: {
        backgroundColor: '$brand',
      },
      false: {
        backgroundColor: '$secondary25',
      },
    },
  } as const,
});

/**
 * Styled text component for step titles.
 * Displayed above the current step on larger screens.
 */
export const StepTitleText = styled(SizableText, {
  color: '$text',
  marginBottom: '$2',
});
